import { ArrowLeftIcon } from "@heroicons/react/solid";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CalendarLogo from "../../assets/svg/calendar.svg";
import { getClientAccessToken } from "../../api/endpoints/calendar/calendarClient";
import { gapi } from "gapi-script";
import { useAuth } from "../../context/AuthContext";
import AlertModal from "../modal/AlertModal";

export default function CalendarSync() {
  const { currentUser }: any = useAuth();
  const cancelSync = !!currentUser?.calendarId;
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const { t } = useTranslation("", {
    keyPrefix: "page.calendar",
  });
  const syncCalendar = () => {
    gapi.load("client:auth2", () =>
      getClientAccessToken(
        cancelSync,
        currentUser?.object_type,
        currentUser?.id
      )
    );
    setOpenConfirm(false);
  };
  return (
    <>
      <div className=" w-full h-fit md:max-w-[523px] bg-white border border-gray-100 shadow rounded-md ">
        <div className="p-6 flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <img src={CalendarLogo} className="h-12 w-12" alt="calender logo" />
            <div className="w-full flex flex-col gap-1">
              <h3 className="font-semibold text-gray-900 text-base">
                {t("syncCalendar")}
              </h3>
              <p className="text-sm text-gray-600">{t("calendarSyncDesc")}</p>
            </div>
          </div>
          <div className="w-full flex justify-end">
            {cancelSync ? (
              <button
                onClick={() => setOpenConfirm(true)}
                className="text-red-600 text-base leading-5 font-medium ltr:pr-4 rtl:pl-4 py-2 border-none w-fit inline-flex items-center bg-transparent"
              >
                {t("cancelSync")}
              </button>
            ) : (
              <button
                type="button"
                className="w-fit inline-flex items-center rounded-md border border-transparent bg-brandblue-600  px-4 py-2.5 text-sm font-medium leading-4 text-white shadow-sm hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
                onClick={() => syncCalendar()}
              >
                <span> {t("sync")}</span>
                <ArrowLeftIcon
                  className="md:ltr:ml-2 md:ltr:-mr-0.5 md:rtl:mr-2 md:rtl:-ml-0.5 h-5 w-5 ltr:rotate-180"
                  aria-hidden="true"
                />
              </button>
            )}
          </div>
        </div>
      </div>
      <AlertModal
        setOpen={() => setOpenConfirm(false)}
        onClose={() => syncCalendar()}
        isOpen={openConfirm}
        description={t("needToCancel")}
        cancelBtnText={t("cancelSync")}
        returnBtnText={t("return")}
      />
    </>
  );
}
